import { CurrencyEnum, PricePlanTypeEnum } from '@systemeio/types'
import {
  PricePlanCreateApiInterface,
  PricePlanCreateInterface,
} from 'modules/digital-product/price-plans/types/price-plan-interface'

/**
 * Turns the create form state into the API payload: the amount is sent in cents and
 * `recurringOptions` is dropped for one-time plans.
 */
export const getPricePlanCreatePayload = (
  pricePlan: PricePlanCreateInterface,
  currency: CurrencyEnum,
): PricePlanCreateApiInterface => {
  const { recurringOptions, ...base } = pricePlan
  const payload = { ...base, amount: Math.round(pricePlan.amount * 100), currency }

  return pricePlan.type === PricePlanTypeEnum.one_shot ? payload : { ...payload, recurringOptions }
}
